<template>
  <div class="w-100">
    <div class="row slim-grid-row mb-4">
      <!-- FIRST NAME -->
      <div class="col-6">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.first-name')}} <span class="font-weight-bold text-danger">*</span></label>
          <input 
            type="text" 
            @input="saveData('first_name')" 
            class="p-3 body-2-1 w-100 border-form radius-6" 
            :class="{'border-danger': error_form.first_name != ''}"
            placeholder="Jhon" 
            v-model="form.first_name" >
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.first_name != ''">{{ error_form.first_name }}</p>
        </div>
      </div>

      <!-- LAST NAME -->
      <div class="col-6">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.last-name')}}</label>
          <input type="text" @input="saveData('last_name')" class="p-3 body-2-1 w-100 border-form radius-6" v-model="form.last_name" >
        </div>
      </div>
    </div>

    <div class="row slim-grid-row mb-4">
      <!-- EMAIL -->
      <div class="col-xl-6 col-12 mb-xl-0 mb-4">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.email')}} <span class="font-weight-bold text-danger">*</span></label>
          <div class="position-relative">
            <input 
            type="text" 
            @input="saveData('email')" 
            class="p-3 body-2-1 w-100 border-form radius-6" 
            :class="{'border-danger': error_form.email != ''}"
            placeholder="email@example.com" 
            v-model="form.email" >
            <div class="position-absolute" style="top:12px;right:16px;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="local_post_office_24px">
                <path id="icon/maps/local_post_office_24px" fill-rule="evenodd" clip-rule="evenodd" d="M22 6C22 4.90002 21.1 4 20 4H4C2.90002 4 2 4.90002 2 6V18C2 19.1 2.90002 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM12 13L4 8V18H20V8L12 13Z" fill="black" fill-opacity="0.54"/>
                </g>
              </svg>
            </div>
          </div>
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.email != ''">{{ error_form.email }}</p>
        </div>
      </div>

      <!-- PHONE -->
      <div class="col-xl-6 col-lg-12">
        <div class="w-100">
          <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.phone-number')}} <span class="font-weight-bold text-danger">*</span></label>
          <div class="position-relative w-100 border-form radius-6" :class="{'border-danger': error_form.phone_number != ''}">
            <div class="row no-gutters">
              <div class="col-4 col-lg-5 col-xl-4 align-self-center">
                <div class="pr-4 border-r-form" style="padding-block: 4px;" :key="form_key">
                  <v-select
                    class="border-none"
                    :clearable="false"
                    :options="data_option.country"
                    @input="refreshFrom()" 
                    label="label" 
                    v-model="form.dial_code">
                      <template #search="{ attributes, events }">
                        <input
                          :placeholder="form.dial_code.code ? '' : '+00'"
                          class="vs__search no-focus-border"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    
                      <template #selected-option="{ dial_code }">
                        <p class="mb-0 body-2-1">{{ dial_code }}</p>
                      </template>
                      <template v-slot:option="option">
                        <div class="d-inline-block align-middle mr-2">
                          <country-flag :country='option.code' size='small'/>
                        </div>
                        <p class="mb-0 d-inline-block align-middle body-2-1">{{`${option.code} (${option.dial_code})`}}</p>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-8 col-lg-7 col-xl-8 align-self-center">
                <input type="number" @input="saveData('phone_number')" class="w-100 border-none no-focus-border body-2-1" placeholder="000 000 000" v-model="form.phone_number" >
              </div>
            </div>
            <div class="position-absolute" style="top:12px;right:16px;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="phone_24px">
                  <path id="icon/communication/phone_24px" fill-rule="evenodd" clip-rule="evenodd" d="M4 3H7.5C8.04999 3 8.5 3.45001 8.5 4C8.5 5.25 8.70001 6.45001 9.07001 7.57001C9.17999 7.92001 9.09998 8.31 8.82001 8.59L6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.61 14.99 15.86 14.89 16.12 14.89C16.22 14.89 16.33 14.9 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45001 3.45001 3 4 3ZM6.54004 5C6.60004 5.89001 6.75 6.76001 6.99005 7.59L5.79004 8.79001C5.38 7.59 5.12006 6.32001 5.03003 5H6.54004ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02Z" fill="black" fill-opacity="0.54"/>
                </g>
              </svg>
            </div>
          </div>
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.phone_number != ''">{{ error_form.phone_number }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters,mapMutations} from 'vuex';
	import country from "@/data/country"
	import { parsePhoneNumber, parsePhoneNumberFromString ,ParseError  } from 'libphonenumber-js'
  import Inputmask from "inputmask";
	import 'inputmask/dist/inputmask.min.js';
	import 'inputmask/dist/bindings/inputmask.binding.js';
  import CountryFlag from 'vue-country-flag'
  import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");

  export default {
    components:{
      CountryFlag
    },
    props: {
      viewtype:{
        type: String,
        default: 'desktop'
      },
      guest_type:{
        type: String,
        default: 'self' //['self','someone']
      }
    },
    data() {
      return {
        data_option:{
          title: ["MR", "MRS", "MISS", "MS"],
          country: country
        },
        form:{
          first_name: '',
		      last_name: '',
		      email: '',
          dial_code: {},
		      phone_number: '',
        },
        error_form:{
          first_name: '',
		      phone_number: '',
		      email: ''
        },
        form_key: 0
      }
    },
    mixins: [validationMixin],
    validations: {
      form:{
        first_name:{
          required
        },
        email: {
          required,
          email
        },
        phone_number:{
          required
        },
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getActivityTrxCustomerDetail'
      ]),
      data(){
				return this.getActivityTrxCustomerDetail
			},
      is_mobile_view(){
        return this.viewtype == 'mobile'
      }
    },
    mounted(){
      this.fillData()
      this.data_option.country = this.data_option.country.map(x=>{
        x.label = `${x.code}/${x.dial_code}`
        return x
      })
      $(document).ready(function(){
        Inputmask().mask(document.querySelectorAll("input"));
      });
    },
    methods:{
      ...mapMutations(['setActivityTrxCustomerDetail']),
      selectPrefix(prefix){
        this.form.title = prefix
        this.saveData('title')
      },
      fillData(){
        this.form = Object.assign({}, this.data)
        this.form.dial_code = {}

        this.checkPhoneNumber(this.form.phone_number)
      },
      refreshFrom(){
        this.form_key++
        this.saveData('dial_code')
      },
      checkPhoneNumber(phone_number){
        if(!(phone_number == '#' || phone_number == '' || phone_number == undefined || phone_number == null)){
          try{
            const phone_parsed = parsePhoneNumberFromString(phone_number)
            if (phone_parsed) {
              this.form.dial_code = this.data_option.country.find(x => x.code == phone_parsed.country)
              this.form.phone_number = phone_parsed.nationalNumber
            }else{
              for(let i = 0; i < this.data_option.country.length; i++){
                let el = this.data_option.country[i]
                let check_country = parsePhoneNumber(phone_number,el.code)
                if(check_country.isValid()){
                  this.form.dial_code = this.data_option.country.find(x => x.code == check_country.country)
                  this.form.phone_number = check_country.nationalNumber
                  break;
                }
                if(i+1 == this.data_option.country.length && !check_country.isValid()){
                  console.log("Invalid phone number")
                  this.setActivityTrxCustomerDetail([
                    {key: 'phone_number', value: ''}
                  ])
                  this.form.phone_number = ''
                }
              }
            }
          }catch(err){
            console.log("PHONE NUMBER ERROR :", err.message)
            this.setActivityTrxCustomerDetail([
              {key: 'phone_number', value: ''}
            ])
            this.form.phone_number = ''
          }
        }
      },
      saveData(field){
        let copy_form = this.$deepCopy(this.form)
        let new_value = copy_form[field]  
        if(field == 'dial_code') {
          new_value =  `${copy_form[field].dial_code}${copy_form.phone_number}`
        }
        if(field == 'phone_number') new_value = `${copy_form.dial_code.dial_code}${copy_form[field]}`
        
        let params = [
          {key: field == 'dial_code' ? 'phone_number' : field, value: new_value}
        ]
        this.setActivityTrxCustomerDetail(params)
      },
      resetErrorMessage(){
        this.error_form = {
          first_name: '',
		      phone_number: '',
		      email: ''
        }
      },
      validateForm(){
        return new Promise((success,fail)=>{
          this.resetErrorMessage()
          let form_val = this.$v.form
          if(form_val.first_name.$invalid){
            this.error_form.first_name = this.$t('hotel.visitor-detail.first-name-warning')
          }
          if(form_val.email.$invalid){
            this.error_form.email = this.$t('hotel.visitor-detail.email-warning')
          }

          let full_pn = `${this.form.dial_code.code}${this.form.phone_number}`
          if(!this.form.dial_code.code){
            this.error_form.phone_number = this.$t('hotel.visitor-detail.country-code-warning')
          }else if(form_val.phone_number.$invalid){
            this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-warning')
          }else if(full_pn.length < 10){
            this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-invalid')
          }

          let isAllFormValid = () => {
            for(let key in this.error_form){
              if(this.error_form.hasOwnProperty(key) && this.error_form[key] != ''){
                return false
              }
            }
            return true
          }
          
          if(isAllFormValid()){
            success()
          }else{
            fail()
          }
        })
      }
    }
  }
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number]{
    -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/activity/GuestForm.vue